import { monthItems } from '@/mocks/home';

export default function MonthRecall() {
  return (
    <section id="month" className="scroll-mt-20 bg-background-50">
      <div className="mx-auto w-full max-w-6xl px-4 py-14 md:px-6 md:py-24">
        <div className="flex flex-col gap-2">
          <p className="text-xs font-semibold uppercase tracking-[0.2em] text-accent-600">月度回望</p>
          <h2 className="font-heading text-2xl font-black tracking-tight md:text-4xl">一瓜一月，进度条拉满</h2>
          <p className="text-sm text-foreground-700 md:text-base">把 2026 摊成十二格，每格都有一颗值得记住的瓜。</p>
        </div>

        <div className="relative mt-10 grid grid-cols-1 gap-x-10 gap-y-0 md:grid-cols-2">
          <span className="absolute left-[15px] top-1 bottom-1 hidden w-px bg-background-200 md:left-1/2 md:block" aria-hidden="true"></span>
          {monthItems.map((it, i) => (
            <div key={it.m} className={`relative flex gap-5 py-3 md:items-center ${i % 2 === 0 ? 'md:justify-end md:pr-12' : 'md:pl-12'}`}>
              <span
                className={`absolute left-[10px] top-[26px] h-2.5 w-2.5 rounded-full ring-4 ring-background-50 md:top-1/2 md:-translate-y-1/2 ${
                  it.type === '年度瓜王' ? 'bg-accent-500' : 'bg-primary-500'
                }`}
                aria-hidden="true"
              ></span>
              <span
                className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-lg font-label text-xs font-bold md:h-9 md:w-9 ${
                  it.type === '年度瓜王' ? 'bg-accent-100 text-accent-800' : 'bg-secondary-100 text-secondary-800'
                }`}
              >
                {it.m}
              </span>
              <div className="min-w-0 border-b border-background-200/70 pb-5">
                <div className="flex flex-wrap items-center gap-x-2 gap-y-1">
                  <h3 className="font-heading text-base font-bold leading-snug text-foreground-950">{it.title}</h3>
                  <span className="whitespace-nowrap rounded-full bg-background-200/70 px-2 py-0.5 text-[11px] font-medium text-foreground-600">{it.type}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}